import { render, staticRenderFns } from "./ColumnInverseChart.vue?vue&type=template&id=20b674a4&scoped=true&lang=pug&"
import script from "./ColumnInverseChart.vue?vue&type=script&lang=ts&"
export * from "./ColumnInverseChart.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnInverseChart.vue?vue&type=style&index=0&id=20b674a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b674a4",
  null
  
)

export default component.exports